import { render, staticRenderFns } from "./WrittenWord.vue?vue&type=template&id=69fc6684&scoped=true&"
import script from "./WrittenWord.vue?vue&type=script&lang=js&"
export * from "./WrittenWord.vue?vue&type=script&lang=js&"
import style0 from "./WrittenWord.vue?vue&type=style&index=0&id=69fc6684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fc6684",
  null
  
)

export default component.exports